import { Link } from "react-router";
import { Section } from "@/components/ds/Section/Section";
import { Container } from "@/components/ds/Container/Container";
import { Text } from "@/components/ds/Text/Text";
import styles from "./Footer.module.css";

export function Footer() {
  return (
    <Section background="cream" padding="sm">
      <Container>
        <footer className={styles.footer}>
          <div className={styles.brand}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 28 28"
              fill="none"
              aria-hidden="true"
            >
              <rect
                width="28"
                height="28"
                rx="6"
                fill="var(--color-accent-solid)"
              />
              <path
                d="M8 14.5L12 18.5L20 10.5"
                stroke="white"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <Text as="span" weight="bold">
              TidyRota
            </Text>
          </div>
          <div className={styles.links}>
            <Link to="/privacy" className={styles.link}>
              Privacy
            </Link>
            <Link to="/terms" className={styles.link}>
              Terms
            </Link>
            <Text size="sm" color="muted">
              Built in the UK
            </Text>
          </div>
        </footer>
      </Container>
    </Section>
  );
}
